export default {
  tracks: [
    {
      "Track ID": "12373",
      Name: "Good One Comin' on",
      Artist: "Blackberry Smoke",
      "Album Artist": "Blackberry Smoke",
      Album: "Little Piece of Dixie",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "7920358",
      "Total Time": "220786",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "12",
      Year: "2009",
      "Date Modified": "2022-04-25T23:41:54Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2009-09-29T12:00:00Z",
      Normalization: "5985",
      "Sort Album": "Little Piece of Dixie",
      "Sort Artist": "Blackberry Smoke",
      "Sort Name": "Good One Comin' on",
      "Persistent ID": "C37C9F6AE0FFBBED",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Blackberry%20Smoke/Little%20Piece%20of%20Dixie/01%20Good%20One%20Comin'%20on.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12375",
      Name: "If I Could",
      Artist: "Barbra Streisand",
      "Album Artist": "Barbra Streisand",
      Composer: "Ron Miller, Ken Hirsch & Marti Sharron",
      Album: "Higher Ground",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "9274765",
      "Total Time": "265373",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "6",
      "Track Count": "12",
      Year: "1997",
      "Date Modified": "2019-11-23T18:14:44Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1997-11-10T08:00:00Z",
      Normalization: "1287",
      "Sort Album": "Higher Ground",
      "Sort Artist": "Barbra Streisand",
      "Sort Name": "If I Could",
      "Persistent ID": "154A1CA5F9FF0762",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Barbra%20Streisand/Higher%20Ground/06%20If%20I%20Could.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12377",
      Name: "Bittersweet",
      Artist: "Big Head Todd & The Monsters",
      "Album Artist": "Big Head Todd & The Monsters",
      Composer: "Todd Park Mohr",
      Album: "Sister Sweetly",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "13549046",
      "Total Time": "376531",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "9",
      "Track Count": "11",
      Year: "1993",
      "Date Modified": "2022-10-10T19:05:53Z",
      "Date Added": "2021-06-12T13:57:30Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1993-02-23T08:00:00Z",
      Normalization: "1441",
      "Sort Album": "Sister Sweetly",
      "Sort Artist": "Big Head Todd & The Monsters",
      "Sort Name": "Bittersweet",
      "Persistent ID": "0AE60AD9EE7611E8",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Big%20Head%20Todd%20&%20The%20Monsters/Sister%20Sweetly/09%20Bittersweet.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12379",
      Name: "Five More Hours",
      Artist: "Deorro & Chris Brown",
      "Album Artist": "Deorro & Chris Brown",
      Composer: "Chris Brown, John Henry Ryan & Julian Collin Bunetta",
      Album: "Five More Hours - Single",
      Genre: "Dance",
      Kind: "Purchased AAC audio file",
      Size: "7751735",
      "Total Time": "211975",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2015",
      "Date Modified": "2019-05-30T16:50:55Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-03-03T08:00:00Z",
      Normalization: "10842",
      "Artwork Count": "1",
      "Sort Album": "Five More Hours - Single",
      "Sort Artist": "Deorro & Chris Brown",
      "Sort Name": "Five More Hours",
      "Persistent ID": "011547CF5FCD7753",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Deorro%20&%20Chris%20Brown/Five%20More%20Hours%20-%20Single/01%20Five%20More%20Hours.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12381",
      Name: "Chances Are (Single Version)",
      Artist: "Johnny Mathis",
      "Album Artist": "Johnny Mathis",
      Composer: "A. Stillman & R. Allen",
      Album: "The Essential Johnny Mathis",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "7373491",
      "Total Time": "182450",
      "Disc Number": "1",
      "Disc Count": "2",
      "Track Number": "5",
      "Track Count": "23",
      Year: "2004",
      "Date Modified": "2019-10-11T18:12:08Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      Comments: "(Single Version)",
      "Release Date": "2004-05-04T07:00:00Z",
      Normalization: "2320",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Essential Johnny Mathis",
      "Sort Artist": "Johnny Mathis",
      "Sort Name": "Chances Are (Single Version)",
      "Persistent ID": "4049ECF66F751FAF",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Essential%20Johnny%20Mathis/1-05%20Chances%20Are%20(Single%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12383",
      Name: "Findin' a Good Man (Album Version)",
      Artist: "Danielle Peck",
      "Album Artist": "Danielle Peck",
      Album: "Danielle Peck (Australian Release)",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "6932694",
      "Total Time": "194133",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "11",
      Year: "2006",
      "Date Modified": "2019-08-09T21:05:40Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      Comments: "(Album Version)",
      "Release Date": "2006-10-01T07:00:00Z",
      Normalization: "9871",
      "Artwork Count": "1",
      "Sort Album": "Danielle Peck",
      "Sort Artist": "Danielle Peck",
      "Sort Name": "Findin' a Good Man (Album Version)",
      "Persistent ID": "25C1D23744A18D35",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Danielle%20Peck/Danielle%20Peck%20(Australian%20Release)/01%20Findin'%20a%20Good%20Man%20(Album%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12385",
      Name: "I Want Candy",
      Artist: "Bow Wow Wow",
      "Album Artist": "Bow Wow Wow",
      Composer: "Gerold Goldstein, Richard Gottehrer, Bert Berns & Bob Feldman",
      Album: "The Best of Bow Wow Wow",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "5959965",
      "Total Time": "164533",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "22",
      Year: "1982",
      "Date Modified": "2021-05-29T02:37:30Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1982-05-28T12:00:00Z",
      Normalization: "1646",
      Compilation: "",
      "Sort Album": "Best of Bow Wow Wow",
      "Sort Artist": "Bow Wow Wow",
      "Sort Name": "I Want Candy",
      "Persistent ID": "426DAF7285712B23",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20Bow%20Wow%20Wow/07%20I%20Want%20Candy.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12387",
      Name: "Hedwig's Theme",
      Artist: "John Williams",
      "Album Artist": "John Williams",
      Composer: "John Williams",
      Album:
        "Harry Potter and the Sorcerer's Stone (Original Motion Picture Soundtrack)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "10644161",
      "Total Time": "309082",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "19",
      "Track Count": "19",
      Year: "2001",
      "Date Modified": "2020-09-19T03:40:38Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2001-10-30T08:00:00Z",
      Normalization: "794",
      "Sort Album": "Harry Potter and the Sorcerer's Stone",
      "Sort Artist": "John Williams",
      "Sort Name": "Hedwig's Theme",
      "Persistent ID": "30FDAFCB8636C045",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/John%20Williams/Harry%20Potter%20and%20the%20Sorcerer's%20Stone%20(Original%20Motion%20Picture%20Soundtrack)/19%20Hedwig's%20Theme.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12389",
      Name: "Bachata en Fukuoka",
      Artist: "Juan Luis Guerra",
      "Album Artist": "Juan Luis Guerra",
      Composer: "Juan Luis Guerra",
      Album: "A Son de Guerra",
      Genre: "Música tropical",
      Kind: "Purchased AAC audio file",
      Size: "6879958",
      "Total Time": "191106",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "5",
      "Track Count": "11",
      Year: "2011",
      "Date Modified": "2019-10-19T21:30:30Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-01-07T08:00:00Z",
      Normalization: "3173",
      "Artwork Count": "1",
      "Sort Album": "Son de Guerra",
      "Sort Artist": "Juan Luis Guerra",
      "Sort Name": "Bachata en Fukuoka",
      "Persistent ID": "37A1C32BA9BDCC98",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Juan%20Luis%20Guerra/A%20Son%20de%20Guerra/05%20Bachata%20en%20Fukuoka.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12391",
      Name: "Firework",
      Artist: "Dallas String Quartet",
      "Album Artist": "Dallas String Quartet",
      Composer:
        "Katy Perry, Esther Dean, Tor Erik Hermansen, Mikkel S. Eriksen & Sandy Wilhelm",
      Album: "Red",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "7817116",
      "Total Time": "222053",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "12",
      Year: "2011",
      "Date Modified": "2020-08-06T18:37:06Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-12-15T08:00:00Z",
      Normalization: "6949",
      "Sort Album": "Red",
      "Sort Artist": "Dallas String Quartet",
      "Sort Name": "Firework",
      "Persistent ID": "C5FA1CDEEDDF0A51",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Dallas%20String%20Quartet/Red/01%20Firework.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12393",
      Name: "Steal My Girl",
      Artist: "One Direction",
      "Album Artist": "One Direction",
      Composer: "N/A",
      Album: "FOUR (The Ultimate Edition)",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "8209931",
      "Total Time": "228138",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "16",
      Year: "2014",
      "Date Modified": "2020-09-04T16:06:23Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-11-17T08:00:00Z",
      Normalization: "5251",
      "Sort Album": "FOUR (The Ultimate Edition)",
      "Sort Artist": "One Direction",
      "Sort Name": "Steal My Girl",
      "Persistent ID": "771888FD8887097F",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/One%20Direction/FOUR%20(The%20Ultimate%20Edition)/01%20Steal%20My%20Girl.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12395",
      Name: "Send in the Clowns (Instrumental Version)",
      Artist: "The O'Neill Brothers",
      "Album Artist": "The O'Neill Brothers",
      Composer: "Stephen Sondheim",
      Album: "On Broadway!",
      Genre: "Instrumental",
      Kind: "Purchased AAC audio file",
      Size: "10038611",
      "Total Time": "294253",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "5",
      "Track Count": "13",
      Year: "2004",
      "Date Modified": "2020-10-15T20:10:48Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-03-16T12:00:00Z",
      Normalization: "1231",
      "Sort Album": "On Broadway!",
      "Sort Album Artist": "O'Neill Brothers",
      "Sort Artist": "O'Neill Brothers",
      "Sort Name": "Send in the Clowns (Instrumental Version)",
      "Persistent ID": "8A8BB756D09BBDC8",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20O'Neill%20Brothers/On%20Broadway!/05%20Send%20in%20the%20Clowns%20(Instrumental%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12397",
      Name: "Suavemente",
      Artist: "Elvis Crespo",
      "Album Artist": "Elvis Crespo",
      Composer: "Elvis Crespo",
      Album: "Suavemente",
      Genre: "Música tropical",
      Kind: "Purchased AAC audio file",
      Size: "9510555",
      "Total Time": "267000",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "10",
      Year: "1998",
      "Date Modified": "2021-08-18T04:13:08Z",
      "Date Added": "2021-08-14T15:16:14Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1998-04-04T08:00:00Z",
      Normalization: "9754",
      "Sort Album": "Suavemente",
      "Sort Artist": "Elvis Crespo",
      "Sort Name": "Suavemente",
      "Persistent ID": "DCD282DAD241998D",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Elvis%20Crespo/Suavemente/01%20Suavemente.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12399",
      Name: "The Promise",
      Artist: "Tracy Chapman",
      "Album Artist": "Tracy Chapman",
      Composer: "Tracy Chapman",
      Album: "New Beginning",
      Genre: "Singer/Songwriter",
      Kind: "Purchased AAC audio file",
      Size: "11251300",
      "Total Time": "327866",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "6",
      "Track Count": "11",
      Year: "1995",
      "Date Modified": "2021-05-01T15:12:31Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1995-11-14T08:00:00Z",
      Normalization: "758",
      "Sort Album": "New Beginning",
      "Sort Artist": "Tracy Chapman",
      "Sort Name": "Promise",
      "Persistent ID": "AEC7C940B9BFA2C4",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Tracy%20Chapman/New%20Beginning/06%20The%20Promise.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12401",
      Name: "Gimme Some Lovin'",
      Artist: "The Spencer Davis Group",
      "Album Artist": "The Spencer Davis Group",
      Album: "The Best of the Spencer Davis Group",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "6274380",
      "Total Time": "176066",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "15",
      Year: "1989",
      "Date Modified": "2020-09-23T18:05:57Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1989-01-01T00:00:00Z",
      Normalization: "4027",
      Compilation: "",
      "Sort Album": "Best of the Spencer Davis Group",
      "Sort Album Artist": "Spencer Davis Group",
      "Sort Artist": "Spencer Davis Group",
      "Sort Name": "Gimme Some Lovin'",
      "Persistent ID": "0D1C819086FBB2FD",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20the%20Spencer%20Davis%20Group/01%20Gimme%20Some%20Lovin'.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12403",
      Name: "Come On Get Higher",
      Artist: "Matt Nathanson",
      "Album Artist": "Matt Nathanson",
      Composer: "Matt Nathanson & Mark Weinberg",
      Album: "Some Mad Hope",
      Genre: "Adult Alternative",
      Kind: "Purchased AAC audio file",
      Size: "7594229",
      "Total Time": "215173",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "12",
      Year: "2007",
      "Date Modified": "2019-08-16T19:03:29Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Play Count": "1",
      "Play Date": "3747494448",
      "Play Date UTC": "2022-10-01T23:40:48Z",
      "Release Date": "2007-08-10T07:00:00Z",
      Normalization: "4356",
      "Artwork Count": "1",
      "Sort Album": "Some Mad Hope",
      "Sort Artist": "Matt Nathanson",
      "Sort Name": "Come On Get Higher",
      "Persistent ID": "F7BD52E732E3343C",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Matt%20Nathanson/Some%20Mad%20Hope/02%20Come%20On%20Get%20Higher.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12405",
      Name: "I'm Gonna Be (500 Miles)",
      Artist: "The Proclaimers",
      "Album Artist": "The Proclaimers",
      Composer: "Charlie Reid & Craig Reid",
      Album: "Sunshine On Leith",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "7723551",
      "Total Time": "219466",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "12",
      Year: "1988",
      "Date Modified": "2021-04-09T19:27:31Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1988-08-01T07:00:00Z",
      Normalization: "4628",
      "Sort Album": "Sunshine On Leith",
      "Sort Album Artist": "Proclaimers",
      "Sort Artist": "Proclaimers",
      "Sort Name": "I'm Gonna Be (500 Miles)",
      "Persistent ID": "7D0727D67ACFDCC3",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20Proclaimers/Sunshine%20On%20Leith/01%20I'm%20Gonna%20Be%20(500%20Miles).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12407",
      Name: "Down With the Sickness",
      Artist: "Disturbed",
      "Album Artist": "Disturbed",
      Composer: "Dan Donegan, David Draiman, Mike Wengren & Steve Kmak",
      Album: "The Sickness",
      Genre: "Hard Rock",
      Kind: "Purchased AAC audio file",
      Size: "10743573",
      "Total Time": "278853",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "12",
      Year: "2000",
      "Date Modified": "2019-10-18T20:09:47Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2000-03-07T08:00:00Z",
      Normalization: "10787",
      "Artwork Count": "1",
      "Sort Album": "Sickness",
      "Sort Artist": "Disturbed",
      "Sort Name": "Down with the Sickness",
      "Persistent ID": "E0805FF0706EDB45",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Disturbed/The%20Sickness/04%20Down%20With%20the%20Sickness.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12409",
      Name: "One Voice",
      Artist: "Billy Gilman",
      "Album Artist": "Billy Gilman",
      Composer: "Don Cook & David Malloy",
      Album: "One Voice",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "9038597",
      "Total Time": "249840",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "11",
      Year: "2000",
      "Date Modified": "2019-05-11T04:53:53Z",
      "Date Added": "2021-08-18T03:59:03Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2000-05-27T07:00:00Z",
      Normalization: "2277",
      "Artwork Count": "1",
      "Sort Album": "One Voice",
      "Sort Artist": "Billy Gilman",
      "Sort Name": "One Voice",
      "Persistent ID": "200F31F9EDBA6471",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Billy%20Gilman/One%20Voice/04%20One%20Voice.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12411",
      Name: "As We Move Forward",
      Artist: "The Family Crest",
      "Album Artist": "The Family Crest",
      Album: "Beneath the Brine",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "9949696",
      "Total Time": "284261",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "9",
      "Track Count": "11",
      Year: "2014",
      "Date Modified": "2019-07-20T00:44:31Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-02-25T08:00:00Z",
      Normalization: "5331",
      "Artwork Count": "1",
      "Sort Album": "Beneath the Brine",
      "Sort Album Artist": "Family Crest",
      "Sort Artist": "Family Crest",
      "Sort Name": "As We Move Forward",
      "Persistent ID": "EEBA9F24401644E2",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20Family%20Crest/Beneath%20the%20Brine/09%20As%20We%20Move%20Forward.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12413",
      Name: "Thinking Out Loud",
      Artist: "Daniel Jang",
      "Album Artist": "Daniel Jang",
      Album: "Thinking Out Loud - Single",
      Genre: "Instrumental",
      Kind: "Purchased AAC audio file",
      Size: "10491770",
      "Total Time": "311922",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2015",
      "Date Modified": "2019-10-18T16:41:55Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-03-12T07:00:00Z",
      Normalization: "3132",
      "Artwork Count": "1",
      "Sort Album": "Thinking Out Loud - Single",
      "Sort Artist": "Daniel Jang",
      "Sort Name": "Thinking Out Loud",
      "Persistent ID": "C22FD362C8B79D66",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Daniel%20Jang/Thinking%20Out%20Loud%20-%20Single/01%20Thinking%20Out%20Loud.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12415",
      Name: "Peanut Butter Jelly",
      Artist: "Galantis",
      "Album Artist": "Galantis",
      Composer:
        "Anthony Bell, Christian Karlsson, Henrik Jonback, Jimmy Koitzsch, Linus Eklöw, Martina Sorbara & Philip Hurtt",
      Album: "Pharmacy",
      Genre: "Dance",
      Kind: "Purchased AAC audio file",
      Size: "7417245",
      "Total Time": "203697",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "9",
      "Track Count": "13",
      Year: "2015",
      "Date Modified": "2020-10-23T17:28:14Z",
      "Date Added": "2021-08-18T03:59:03Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-04-20T07:00:00Z",
      Normalization: "8044",
      "Sort Album": "Pharmacy",
      "Sort Artist": "Galantis",
      "Sort Name": "Peanut Butter Jelly",
      "Persistent ID": "C3522270F373F47A",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Galantis/Pharmacy/09%20Peanut%20Butter%20Jelly.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12417",
      Name: "Piano Concerto No. 21 In C Major, K. 467: II. Andante",
      Artist: "Finghin Collins, London Philharmonic Orchestra & David Parry",
      "Album Artist": "London Philharmonic Orchestra & David Parry",
      Composer: "Wolfgang Amadeus Mozart",
      Album: "The 50 Greatest Pieces of Classical Music",
      Work: "Piano Concerto No. 21 in C Major, K. 467",
      "Movement Number": "2",
      "Movement Count": "3",
      "Movement Name": "Andante",
      Genre: "Classical",
      Kind: "Purchased AAC audio file",
      Size: "15009889",
      "Total Time": "437978",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "13",
      "Track Count": "50",
      Year: "2005",
      "Date Modified": "2019-05-02T19:39:22Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2005-09-15T07:00:00Z",
      Normalization: "586",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "50 Greatest Pieces of Classical Music",
      "Sort Artist":
        "Finghin Collins, London Philharmonic Orchestra & David Parry",
      "Sort Name": "Piano Concerto No. 21 In C Major, K. 467: II. Andante",
      "Persistent ID": "896DD6D19CB645F3",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%2050%20Greatest%20Pieces%20of%20Classical%20Music/13%20Piano%20Concerto%20No.%2021%20In%20C%20Major,%20K.%20467_%20II.%20Andante.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12419",
      Name: "No One's Gonna Love You",
      Artist: "Band of Horses",
      "Album Artist": "Band of Horses",
      Composer: "Band of Horses",
      Album: "Cease to Begin",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "7556780",
      "Total Time": "217333",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "3",
      "Track Count": "10",
      Year: "2007",
      "Date Modified": "2020-09-19T03:25:12Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2007-10-09T07:00:00Z",
      Normalization: "8110",
      "Sort Album": "Cease to Begin",
      "Sort Artist": "Band of Horses",
      "Sort Name": "No One's Gonna Love You",
      "Persistent ID": "EFF9EE4CBF69E5B2",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Band%20of%20Horses/Cease%20to%20Begin/03%20No%20One's%20Gonna%20Love%20You.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12421",
      Name: "New Slang",
      Artist: "The Shins",
      "Album Artist": "The Shins",
      Album: "Oh, Inverted World",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "8682266",
      "Total Time": "231173",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "6",
      "Track Count": "11",
      Year: "2001",
      "Date Modified": "2020-09-19T03:38:27Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2001-06-19T07:00:00Z",
      Normalization: "1272",
      "Sort Album": "Oh, Inverted World",
      "Sort Album Artist": "Shins",
      "Sort Artist": "Shins",
      "Sort Name": "New Slang",
      "Persistent ID": "9D9B27BDB271B707",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20Shins/Oh,%20Inverted%20World/06%20New%20Slang.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12423",
      Name: "Main Title",
      Artist: "Aaron Zigman",
      "Album Artist": "Various Artists",
      Composer: "Aaron Zigman",
      Album: "The Notebook (Original Motion Picture Soundtrack)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "6222613",
      "Total Time": "169466",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "15",
      Year: "2004",
      "Date Modified": "2019-06-14T01:09:07Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-06-08T07:00:00Z",
      Normalization: "333",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Notebook (Original Motion Picture Soundtrack)",
      "Sort Artist": "Aaron Zigman",
      "Sort Name": "Main Title",
      "Persistent ID": "710226675EAC394C",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Notebook%20(Original%20Motion%20Picture%20Soundtrack)/01%20Main%20Title.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12425",
      Name: "Miami",
      Artist: "Will Smith",
      "Album Artist": "Will Smith",
      Composer:
        "Will Smith, Ryan Toby, William Shelby, Leon Sylvers III, Stephen Shockley & Samuel J. Barnes",
      Album: "Big Willie Style",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "7164056",
      "Total Time": "197560",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "8",
      "Track Count": "16",
      Year: "1997",
      "Date Modified": "2021-08-18T04:14:55Z",
      "Date Added": "2021-07-16T01:26:26Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1997-11-25T08:00:00Z",
      Normalization: "1941",
      "Sort Album": "Big Willie Style",
      "Sort Artist": "Will Smith",
      "Sort Name": "Miami",
      "Persistent ID": "3993556973AA20F6",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Will%20Smith/Big%20Willie%20Style/08%20Miami.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12427",
      Name: "The Throne Room (Instrumental)",
      Artist: "John Williams",
      "Album Artist": "Various Artists",
      Composer: "John Williams",
      Album: "Disneyland Resort Official Album",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "3182530",
      "Total Time": "57640",
      "Disc Number": "2",
      "Disc Count": "2",
      "Track Number": "2",
      "Track Count": "19",
      Year: "2013",
      "Date Modified": "2019-05-03T16:29:48Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      Comments: "(Instrumental)",
      "Release Date": "2013-01-01T08:00:00Z",
      Normalization: "1730",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Disneyland Resort Official Album",
      "Sort Artist": "John Williams",
      "Sort Name": "Throne Room (Instrumental)",
      "Persistent ID": "5C5FE5F4AD1D2276",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Disneyland%20Resort%20Official%20Album/2-02%20The%20Throne%20Room%20(Instrumental).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12429",
      Name: "Moonlight Sonata",
      Artist: "Smart Sleep With Classical",
      "Album Artist": "Smart Sleep With Classical",
      Album: "Smart Sleep With Classical",
      Genre: "Children's Music",
      Kind: "Purchased AAC audio file",
      Size: "11398092",
      "Total Time": "332933",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "13",
      "Track Count": "15",
      Year: "2000",
      "Date Modified": "2019-05-02T19:46:08Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2000-10-31T08:00:00Z",
      Normalization: "327",
      "Artwork Count": "1",
      "Sort Album": "Smart Sleep With Classical",
      "Sort Artist": "Smart Sleep With Classical",
      "Sort Name": "Moonlight Sonata",
      "Persistent ID": "A888F51A5037021E",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Smart%20Sleep%20With%20Classical/Smart%20Sleep%20With%20Classical/13%20Moonlight%20Sonata.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12431",
      Name: "Pachelbel Meets U2",
      Artist: "Jon Schmidt",
      "Album Artist": "Jon Schmidt",
      Composer: "David Evans (GB 2), Paul David Hewson & Laurence Mullen",
      Album: "Winter Serenade",
      Genre: "New Age",
      Kind: "Purchased AAC audio file",
      Size: "11944922",
      "Total Time": "343866",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "10",
      Year: "2004",
      "Date Modified": "2021-05-05T16:38:21Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-09-13T12:00:00Z",
      Normalization: "1147",
      "Sort Album": "Winter Serenade",
      "Sort Artist": "Jon Schmidt",
      "Sort Name": "Pachelbel Meets U2",
      "Persistent ID": "E750DC68563C3BD3",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Jon%20Schmidt/Winter%20Serenade/02%20Pachelbel%20Meets%20U2.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12433",
      Name: "It's the Most Wonderful Time of the Year",
      Artist: "Andy Williams",
      "Album Artist": "Andy Williams",
      Composer: "Edward Pola",
      Album: "The Andy Williams Christmas Album",
      Genre: "Holiday",
      Kind: "Purchased AAC audio file",
      Size: "6213982",
      "Total Time": "152570",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "12",
      Year: "1963",
      "Date Modified": "2019-12-21T17:17:09Z",
      "Date Added": "2021-08-18T03:59:03Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1963-10-14T07:00:00Z",
      Normalization: "7589",
      "Sort Album": "Andy Williams Christmas Album",
      "Sort Artist": "Andy Williams",
      "Sort Name": "It's the Most Wonderful Time of the Year",
      "Persistent ID": "246F6E713539E98C",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Andy%20Williams/The%20Andy%20Williams%20Christmas%20Album/04%20It's%20the%20Most%20Wonderful%20Time%20of%20the%20Year.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12435",
      Name: "Where the Party At (feat. Nelly) [LP Mix featuring Nelly]",
      Artist: "Jagged Edge featuring Nelly",
      "Album Artist": "Jagged Edge",
      Composer:
        "Nelly, Jermaine Dupri, Brandon Casey, Bryan-Michael Cox & Brian Casey",
      Album: "Where the Party At - EP",
      Genre: "R&B/Soul",
      Kind: "Purchased AAC audio file",
      Size: "8293882",
      "Total Time": "234066",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "5",
      Year: "2001",
      "Date Modified": "2020-09-26T15:19:41Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2001-05-14T07:00:00Z",
      Normalization: "4191",
      "Sort Album": "Where the Party At - EP",
      "Sort Artist": "Jagged Edge featuring Nelly",
      "Sort Name": "Where the Party At (feat. Nelly) [LP Mix featuring Nelly]",
      "Persistent ID": "18243CFC0FBC0D9B",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Jagged%20Edge/Where%20the%20Party%20At%20-%20EP/01%20Where%20the%20Party%20At%20(feat.%20Nelly)%20%5BLP%20Mix%20featuring%20Nelly%5D.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12437",
      Name: "Top Gun Anthem",
      Artist: "Harold Faltermeyer & Steve Stevens",
      "Album Artist": "Various Artists",
      Composer: "H. Faltermeyer",
      Album:
        "Top Gun (Original Motion Picture Soundtrack) [Special Expanded Edition]",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "9634327",
      "Total Time": "253333",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "10",
      "Track Count": "15",
      Year: "1986",
      "Date Modified": "2019-09-07T14:33:52Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1986-05-13T07:00:00Z",
      Normalization: "3556",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album":
        "Top Gun (Original Motion Picture Soundtrack) [Special Expanded Edition]",
      "Sort Artist": "Harold Faltermeyer & Steve Stevens",
      "Sort Name": "Top Gun Anthem",
      "Persistent ID": "A9CEF0FF81B37DE9",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Top%20Gun%20(Original%20Motion%20Picture%20Soundtrack)%20%5BSpecial%20Expanded%20Edition%5D/10%20Top%20Gun%20Anthem.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12439",
      Name: "I'll Be",
      Artist: "Edwin McCain",
      "Album Artist": "Edwin McCain",
      Composer: "Edwin McCain",
      Album: "Misguided Roses",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "10406224",
      "Total Time": "266533",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "13",
      Year: "1997",
      "Date Modified": "2019-06-13T23:27:59Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1997-06-24T07:00:00Z",
      Normalization: "6587",
      "Artwork Count": "1",
      "Sort Album": "Misguided Roses",
      "Sort Artist": "Edwin McCain",
      "Sort Name": "I'll Be",
      "Persistent ID": "67D78C2847F6838F",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Edwin%20McCain/Misguided%20Roses/04%20I'll%20Be.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12441",
      Name: "The Big Comfy Couch Theme Song (feat. Erin Fitz-James, Stella Fridiedrich, Elizabeth White, Hannah Gibson, Noah Klar, Olivia Krys, Henry Mills, Martyne Alphonzo, Gabriela Caceres, Marial Addario-Depoe, Ashia Gonzalez, Patrick Luongo, Marieke Pynn-Coates,",
      Artist: "Aidan Leitch",
      "Album Artist": "Various Artists",
      Composer: "J.P Houston",
      Album: "Silly Me",
      Genre: "Children's Music",
      Kind: "Purchased AAC audio file",
      Size: "2691074",
      "Total Time": "64314",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "16",
      Year: "2013",
      "Date Modified": "2021-04-24T14:00:41Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2013-04-01T07:00:00Z",
      Normalization: "738",
      Compilation: "",
      "Sort Album": "Silly Me",
      "Sort Artist": "Aidan Leitch",
      "Sort Name":
        "Big Comfy Couch Theme Song (feat. Erin Fitz-James, Stella Fridiedrich, Elizabeth White, Hannah Gibson, Noah Klar, Olivia Krys, Henry Mills, Martyne Alphonzo, Gabriela Caceres, Marial Addario-Depoe, Ashia Gonzalez, Patrick Luongo, Marieke Pynn-Coates,",
      "Persistent ID": "460080BE04E7D1C1",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Silly%20Me/01%20The%20Big%20Comfy%20Couch%20Theme%20Song%20(feat.%20Erin%20Fitz-James,%20Stella%20Fridiedrich,%20Elizabeth%20White,%20Hannah%20Gibson,%20Noah%20Klar,%20Olivia%20Krys,%20Henry%20Mills,%20Martyne%20Alphonzo,%20Gabriela%20Caceres,%20Marial%20Addario-Depoe,%20Ashia%20Gonzalez,%20Patrick%20Luongo,%20Marieke%20Pynn.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12443",
      Name: "No Hands (feat. Roscoe Dash & Wale)",
      Artist: "Waka Flocka Flame",
      "Album Artist": "Waka Flocka Flame",
      Composer: "C. Gholson, J. Johnson, J. Malphurs & O. Akintimehin",
      Album: "No Hands (feat. Roscoe Dash & Wale) - Single",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "9787077",
      "Total Time": "266649",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2010",
      "Date Modified": "2020-08-29T17:59:38Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Skip Count": "1",
      "Skip Date": "2021-10-18T17:01:54Z",
      "Release Date": "2010-09-06T07:00:00Z",
      Normalization: "3215",
      "Artwork Count": "1",
      "Sort Album": "No Hands (feat. Roscoe Dash & Wale) - Single",
      "Sort Artist": "Waka Flocka Flame",
      "Sort Name": "No Hands (feat. Roscoe Dash & Wale)",
      "Persistent ID": "3051A76D0B1D2B4F",
      Clean: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Waka%20Flocka%20Flame/No%20Hands%20(feat.%20Roscoe%20Dash%20&%20Wale)%20-%20Single/01%20No%20Hands%20(feat.%20Roscoe%20Dash%20&%20Wale).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12445",
      Name: "Loves Me Like a Rock",
      Artist: "Paul Simon",
      "Album Artist": "Paul Simon",
      Composer: "Paul Simon & Paul Simon",
      Album: "The Essential Paul Simon",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "8546687",
      "Total Time": "220413",
      "Disc Number": "1",
      "Disc Count": "2",
      "Track Number": "2",
      "Track Count": "19",
      Year: "2007",
      "Date Modified": "2020-11-28T19:41:22Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2007-06-26T07:00:00Z",
      Normalization: "1428",
      Compilation: "",
      "Sort Album": "Essential Paul Simon",
      "Sort Artist": "Paul Simon",
      "Sort Name": "Loves Me Like a Rock",
      "Persistent ID": "B0D4202BA9DF141F",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Essential%20Paul%20Simon/1-02%20Loves%20Me%20Like%20a%20Rock.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12447",
      Name: "Trumpet Voluntary in D Major (The Prince Of Denamrk's March)",
      Artist: "Suddeutsche Philharmonie",
      "Album Artist": "Various Artists",
      Composer: "Jeremiah Clarke",
      Album: "Royal Wedding Classics",
      Genre: "Classical",
      Kind: "Purchased AAC audio file",
      Size: "6200633",
      "Total Time": "176493",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "20",
      Year: "1999",
      "Date Modified": "2019-05-02T19:58:51Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      Comments: "(The Prince Of Denamrk's March)",
      "Release Date": "1999-01-01T08:00:00Z",
      Normalization: "862",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Royal Wedding Classics",
      "Sort Artist": "Suddeutsche Philharmonie",
      "Sort Name":
        "Trumpet Voluntary in D Major (The Prince Of Denamrk's March)",
      "Persistent ID": "0423E7E6A58821FA",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Royal%20Wedding%20Classics/07%20Trumpet%20Voluntary%20in%20D%20Major%20(The%20Prince%20Of%20Denamrk's%20March).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12449",
      Name: "Stamp On the Ground (Radio Edit)",
      Artist: "ItaloBrothers",
      "Album Artist": "ItaloBrothers",
      Composer:
        "Nachtverbindung & Zacharias Adrian, Nachtverbindung & Zacharias Adrian",
      Album: "Stamp On the Ground",
      Genre: "Dance",
      Kind: "Purchased AAC audio file",
      Size: "7245577",
      "Total Time": "196905",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "8",
      Year: "2009",
      "Date Modified": "2021-08-18T04:13:27Z",
      "Date Added": "2021-06-13T02:34:10Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2009-07-01T12:00:00Z",
      Normalization: "2952",
      "Sort Album": "Stamp On the Ground",
      "Sort Artist": "ItaloBrothers",
      "Sort Name": "Stamp On the Ground (Radio Edit)",
      "Persistent ID": "189727C711A25B35",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/ItaloBrothers/Stamp%20On%20the%20Ground/01%20Stamp%20On%20the%20Ground%20(Radio%20Edit).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12451",
      Name: "Bring It Back",
      Artist: "Travis Porter",
      "Album Artist": "Travis Porter",
      Composer: "Donquez Woods, Harold Duncan, Lakeem Mattox & Markous Roberts",
      Album: "Bring It Back - Single",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "7724610",
      "Total Time": "216240",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2011",
      "Date Modified": "2021-06-04T19:30:34Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-02-07T08:00:00Z",
      Normalization: "6244",
      "Sort Album": "Bring It Back - Single",
      "Sort Artist": "Travis Porter",
      "Sort Name": "Bring It Back",
      "Persistent ID": "D2688C557493D457",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Travis%20Porter/Bring%20It%20Back%20-%20Single/01%20Bring%20It%20Back.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12453",
      Name: "Come With Me Now",
      Artist: "KONGOS",
      "Album Artist": "KONGOS",
      Composer: "John Joseph Kongos",
      Album: "Lunatic",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "7938425",
      "Total Time": "211960",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "12",
      Year: "2012",
      "Date Modified": "2020-10-23T17:32:59Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-12-28T08:00:00Z",
      Normalization: "9562",
      "Sort Album": "Lunatic",
      "Sort Artist": "KONGOS",
      "Sort Name": "Come With Me Now",
      "Persistent ID": "16DCB31F7355DB2C",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/KONGOS/Lunatic/02%20Come%20With%20Me%20Now.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12455",
      Name: "I Love the Way You Love Me",
      Artist: "John Michael Montgomery",
      "Album Artist": "John Michael Montgomery",
      Composer: "Chuck Cannon & Victoria Shaw",
      Album: "The Very Best of John Michael Montgomery",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "8852439",
      "Total Time": "242733",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "20",
      Year: "1992",
      "Date Modified": "2021-08-18T04:13:40Z",
      "Date Added": "2021-06-12T19:43:46Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1992-10-13T07:00:00Z",
      Normalization: "2108",
      Compilation: "",
      "Sort Album": "Very Best of John Michael Montgomery",
      "Sort Artist": "John Michael Montgomery",
      "Sort Name": "I Love the Way You Love Me",
      "Persistent ID": "7CEC96E3CB44000E",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Very%20Best%20of%20John%20Michael%20Montgomery/07%20I%20Love%20the%20Way%20You%20Love%20Me.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12457",
      Name: "Love Me Like You Do",
      Artist: "DSharp",
      "Album Artist": "DSharp",
      Album: "Love Me Like You Do - Single",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "8743615",
      "Total Time": "249315",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2015",
      "Date Modified": "2021-11-12T17:08:50Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-08-07T12:00:00Z",
      Normalization: "5902",
      "Artwork Count": "1",
      "Sort Album": "Love Me Like You Do - Single",
      "Sort Artist": "DSharp",
      "Sort Name": "Love Me Like You Do",
      "Persistent ID": "7ADEACC33E1FE8C0",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/DSharp/Love%20Me%20Like%20You%20Do%20-%20Single/01%20Love%20Me%20Like%20You%20Do.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12459",
      Name: "I Like That",
      Artist: "Houston, Nate Dogg, I-20 & Chingy",
      "Album Artist": "Houston, Chingy, I-20 & Nate Dogg",
      Album: "I Like That - Single",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "9443331",
      "Total Time": "237893",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2003",
      "Date Modified": "2021-08-18T04:13:23Z",
      "Date Added": "2021-06-18T20:25:06Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2003-10-07T12:00:00Z",
      Normalization: "4474",
      "Sort Album": "I Like That - Single",
      "Sort Artist": "Houston, Nate Dogg, I-20 & Chingy",
      "Sort Name": "I Like That",
      "Persistent ID": "A520C42DAEC80C4D",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Houston,%20Chingy,%20I-20%20&%20Nate%20Dogg/I%20Like%20That%20-%20Single/01%20I%20Like%20That.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12461",
      Name: "Not Enough Time",
      Artist: "INXS",
      "Album Artist": "INXS",
      Composer: "Andrew Farriss & Michael Hutchence",
      Album: "The Best of INXS",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "8846165",
      "Total Time": "250613",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "18",
      "Track Count": "21",
      Year: "2002",
      "Date Modified": "2019-10-26T01:00:53Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2002-06-04T07:00:00Z",
      Normalization: "3687",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Best of INXS",
      "Sort Artist": "INXS",
      "Sort Name": "Not Enough Time",
      "Persistent ID": "010505D28E22B371",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20INXS/18%20Not%20Enough%20Time.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12463",
      Name: "Here Comes the Sun",
      Artist: "United Guitar Players",
      "Album Artist": "United Guitar Players",
      Album:
        "Here Comes the Sun - Instrumental Acoustic Guitar Songs from the 50s, 60s, 70s & 80s",
      Genre: "Instrumental",
      Kind: "Purchased AAC audio file",
      Size: "6665946",
      "Total Time": "185376",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "22",
      Year: "2013",
      "Date Modified": "2021-11-26T17:42:56Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2013-10-24T07:00:00Z",
      Normalization: "1897",
      "Sort Album":
        "Here Comes the Sun - Instrumental Acoustic Guitar Songs from the 50s, 60s, 70s & 80s",
      "Sort Artist": "United Guitar Players",
      "Sort Name": "Here Comes the Sun",
      "Persistent ID": "5237692898144057",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/United%20Guitar%20Players/Here%20Comes%20the%20Sun%20-%20Instrumental%20Acoustic%20Guitar%20Songs%20from%20the%2050s,%2060s,%2070s%20&%2080s/01%20Here%20Comes%20the%20Sun.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12465",
      Name: "Dance With Me",
      Artist: "Orleans",
      "Album Artist": "Orleans",
      Composer: "Johanna D. Hall & John Joseph Hall",
      Album: "Dance With Me: The Best of Orleans",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "7064155",
      "Total Time": "180479",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "3",
      "Track Count": "18",
      Year: "1997",
      "Date Modified": "2019-12-21T17:19:13Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1997-06-24T07:00:00Z",
      Normalization: "1819",
      Compilation: "",
      "Sort Album": "Dance With Me: The Best of Orleans",
      "Sort Artist": "Orleans",
      "Sort Name": "Dance With Me",
      "Persistent ID": "85876F7C58FABE88",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Dance%20With%20Me_%20The%20Best%20of%20Orleans/03%20Dance%20With%20Me.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12467",
      Name: "Never Alone (feat. Lady Antebellum)",
      Artist: "Jim Brickman",
      "Album Artist": "Jim Brickman",
      Album: "Never Alone",
      Genre: "New Age",
      Kind: "Purchased AAC audio file",
      Size: "8334236",
      "Total Time": "221910",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "10",
      Year: "2002",
      "Date Modified": "2021-05-29T02:36:32Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      Comments: "(feat. Lady Antebellum)",
      "Release Date": "2002-02-04T12:00:00Z",
      Normalization: "3862",
      Compilation: "",
      "Sort Album": "Never Alone",
      "Sort Artist": "Jim Brickman",
      "Sort Name": "Never Alone (feat. Lady Antebellum)",
      "Persistent ID": "C8408A5DCACC840A",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Never%20Alone/01%20Never%20Alone%20(feat.%20Lady%20Antebellum).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12469",
      Name: "WWE: New Day, New Way (The New Day)",
      Artist: "Jim Johnston",
      "Album Artist": "Jim Johnston",
      Composer: "Jim Johnston",
      Album: "WWE: New Day, New Way (The New Day) - Single",
      Genre: "Christian",
      Kind: "Purchased AAC audio file",
      Size: "5587080",
      "Total Time": "154907",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2014",
      "Date Modified": "2021-05-22T15:59:43Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-12-03T12:00:00Z",
      Normalization: "1269",
      "Sort Album": "WWE: New Day, New Way (The New Day) - Single",
      "Sort Artist": "Jim Johnston",
      "Sort Name": "WWE: New Day, New Way (The New Day)",
      "Persistent ID": "7B586973076B22DB",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Jim%20Johnston/WWE_%20New%20Day,%20New%20Way%20(The%20New%20Day)%20-%20Single/01%20WWE_%20New%20Day,%20New%20Way%20(The%20New%20Day).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12471",
      Name: "Love T.K.O.",
      Artist: "Teddy Pendergrass",
      "Album Artist": "Teddy Pendergrass",
      Composer: "Gip Noble, Cecil Womack & Linda Womack",
      Album: "The Essential Teddy Pendergrass",
      Genre: "R&B/Soul",
      Kind: "Purchased AAC audio file",
      Size: "11736815",
      "Total Time": "299586",
      "Disc Number": "1",
      "Disc Count": "2",
      "Track Number": "6",
      "Track Count": "14",
      Year: "1980",
      "Date Modified": "2019-10-11T17:41:02Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1980-01-01T12:00:00Z",
      Normalization: "1229",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Essential Teddy Pendergrass",
      "Sort Artist": "Teddy Pendergrass",
      "Sort Name": "Love T.K.O.",
      "Persistent ID": "38F8CF4BEA9797B9",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Essential%20Teddy%20Pendergrass/1-06%20Love%20T.K.O..m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12473",
      Name: "Me Tiene Loco",
      Artist: "Puerto Rican Power",
      "Album Artist": "Puerto Rican Power",
      Album: "Wild, Wild Salsa",
      Genre: "Música tropical",
      Kind: "Purchased AAC audio file",
      Size: "9650732",
      "Total Time": "262964",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "8",
      Year: "2001",
      "Date Modified": "2019-10-18T16:05:45Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2001-07-17T12:00:00Z",
      Normalization: "2693",
      "Artwork Count": "1",
      "Sort Album": "Wild, Wild Salsa",
      "Sort Artist": "Puerto Rican Power",
      "Sort Name": "Me Tiene Loco",
      "Persistent ID": "14CCD50C408238E8",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Puerto%20Rican%20Power/Wild,%20Wild%20Salsa/02%20Me%20Tiene%20Loco.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12475",
      Name: "Red Robin",
      Artist: "Clark Richard",
      "Album Artist": "Clark Richard",
      Composer: "Clark Richard",
      Album: "Kissing Kelley - EP",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "8384566",
      "Total Time": "237440",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "4",
      Year: "2010",
      "Date Modified": "2020-10-03T18:11:51Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2010-08-24T07:00:00Z",
      Normalization: "1985",
      "Sort Album": "Kissing Kelley - EP",
      "Sort Artist": "Clark Richard",
      "Sort Name": "Red Robin",
      "Persistent ID": "C4CB37AC92CAC089",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Clark%20Richard/Kissing%20Kelley%20-%20EP/02%20Red%20Robin.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12477",
      Name: "When I Fall In Love",
      Artist: 'Nat "King" Cole',
      "Album Artist": 'Nat "King" Cole',
      Album: "Nat King Cole",
      Genre: "Jazz",
      Kind: "Purchased AAC audio file",
      Size: "6841102",
      "Total Time": "190666",
      "Disc Number": "3",
      "Disc Count": "4",
      "Track Number": "18",
      "Track Count": "26",
      Year: "1992",
      "Date Modified": "2020-10-30T18:27:23Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1992-11-02T08:00:00Z",
      Normalization: "684",
      Compilation: "",
      "Sort Album": "Nat King Cole",
      "Sort Artist": 'Nat "King" Cole',
      "Sort Name": "When I Fall In Love",
      "Persistent ID": "A0D49A9A918AC80C",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Nat%20King%20Cole/3-18%20When%20I%20Fall%20In%20Love.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12479",
      Name: "Marry Me (Instrumental Version)",
      Artist: "United Guitar Players",
      "Album Artist": "United Guitar Players",
      Album:
        "Popular Wedding Songs on Spanish Acoustic Guitars: Instrumental Wedding Guitar Music, Vol. 2",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "7424922",
      "Total Time": "207238",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "18",
      Year: "2014",
      "Date Modified": "2020-07-18T16:24:27Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-12-11T08:00:00Z",
      Normalization: "1434",
      "Sort Album":
        "Popular Wedding Songs on Spanish Acoustic Guitars: Instrumental Wedding Guitar Music, Vol. 2",
      "Sort Artist": "United Guitar Players",
      "Sort Name": "Marry Me (Instrumental Version)",
      "Persistent ID": "AF230BDFCEBF0480",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/United%20Guitar%20Players/Popular%20Wedding%20Songs%20on%20Spanish%20Acoustic%20Guitars_%20Instrumental%20Wedding%20Guitar%20Music,%20Vol.%202/01%20Marry%20Me%20(Instrumental%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12481",
      Name: "Trashy Women",
      Artist: "Confederate Railroad",
      "Album Artist": "Confederate Railroad",
      Composer: "Chris Wall",
      Album: "Confederate Railroad (Remastered)",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "6988893",
      "Total Time": "194738",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "10",
      "Track Count": "10",
      Year: "1992",
      "Date Modified": "2020-09-26T15:19:39Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1992-04-07T12:00:00Z",
      Normalization: "3878",
      "Sort Album": "Confederate Railroad",
      "Sort Artist": "Confederate Railroad",
      "Sort Name": "Trashy Women",
      "Persistent ID": "77124DAFB917C4D3",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Confederate%20Railroad/Confederate%20Railroad%20(Remastered)/10%20Trashy%20Women.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12483",
      Name: "Love Theme",
      Artist: "John Debney & Tony Morales",
      "Album Artist": "John Debney & Tony Morales",
      Album: "Hatfields & McCoys (Soundtrack from the Mini Series)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "6519985",
      "Total Time": "175346",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "11",
      "Track Count": "39",
      Year: "2012",
      "Date Modified": "2019-09-13T21:09:59Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-05-22T07:00:00Z",
      Normalization: "972",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Hatfields & McCoys (Soundtrack from the Mini Series)",
      "Sort Artist": "John Debney & Tony Morales",
      "Sort Name": "Love Theme",
      "Persistent ID": "FE35D919677CC8B3",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Hatfields%20&%20McCoys%20(Soundtrack%20from%20the%20Mini%20Series)/11%20Love%20Theme.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12485",
      Name: "Burning Down the House (Live)",
      Artist: "Talking Heads",
      "Album Artist": "Talking Heads",
      Composer: "Chris Frantz, David Byrne, Jerry Harrison & Tina Weymouth",
      Album: "Stop Making Sense (Live) [Special New Edition]",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "8913662",
      "Total Time": "246306",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "6",
      "Track Count": "16",
      Year: "1984",
      "Date Modified": "2021-07-02T18:48:03Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1984-09-12T07:00:00Z",
      Normalization: "2143",
      "Sort Album": "Stop Making Sense (Live) [Special New Edition]",
      "Sort Artist": "Talking Heads",
      "Sort Name": "Burning Down the House (Live)",
      "Persistent ID": "AC124084D04AEA97",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Talking%20Heads/Stop%20Making%20Sense%20(Live)%20%5BSpecial%20New%20Edition%5D/06%20Burning%20Down%20the%20House%20(Live).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12487",
      Name: "Daddy's Little Girl",
      Artist: "David Glenn",
      "Album Artist": "David Glenn",
      Album: "Songs for the Heart",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "8988543",
      "Total Time": "257437",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "10",
      Year: "2008",
      "Date Modified": "2019-10-03T21:48:08Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2008-04-04T07:00:00Z",
      Normalization: "2301",
      "Artwork Count": "1",
      "Sort Album": "Songs for the Heart",
      "Sort Artist": "David Glenn",
      "Sort Name": "Daddy's Little Girl",
      "Persistent ID": "A15AA3385D30C7A9",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/David%20Glenn/Songs%20for%20the%20Heart/04%20Daddy's%20Little%20Girl.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12489",
      Name: "Ass Drop",
      Artist: "Wiz Khalifa",
      "Album Artist": "Wiz Khalifa",
      Composer: "Cameron Thomaz, Isaac De Boni, James Scheffer & Michael Mule",
      Album: "Blacc Hollywood (Deluxe Version)",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "6145199",
      "Total Time": "166712",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "6",
      "Track Count": "13",
      Year: "2014",
      "Date Modified": "2019-11-14T18:48:08Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-08-19T07:00:00Z",
      Normalization: "1945",
      "Sort Album": "Blacc Hollywood (Deluxe Version)",
      "Sort Artist": "Wiz Khalifa",
      "Sort Name": "Ass Drop",
      "Persistent ID": "4C34EB04F86975DB",
      Clean: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Wiz%20Khalifa/Blacc%20Hollywood%20(Deluxe%20Version)/06%20Ass%20Drop.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12491",
      Name: "Ave Maria",
      Artist: "Yo-Yo Ma & Kathryn Stott",
      "Album Artist": "Yo-Yo Ma & Kathryn Stott",
      Composer: "Johann Sebastian Bach & Charles Gounod",
      Album: "Songs from the Arc of Life",
      Work: "Ave Maria (Arr. for Cello and Piano)",
      "Movement Name": "Ave Maria (Arr. for Cello and Piano)",
      Genre: "Classical",
      Kind: "Purchased AAC audio file",
      Size: "5728018",
      "Total Time": "163173",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "19",
      Year: "2004",
      "Date Modified": "2019-05-02T19:48:02Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-09-28T07:00:00Z",
      Normalization: "106",
      "Artwork Count": "1",
      "Sort Album": "Songs from the Arc of Life",
      "Sort Artist": "Yo-Yo Ma & Kathryn Stott",
      "Sort Name": "Ave Maria",
      "Persistent ID": "1C688545C9F0D325",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Yo-Yo%20Ma%20&%20Kathryn%20Stott/Songs%20from%20the%20Arc%20of%20Life/01%20Ave%20Maria.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12493",
      Name: "Cadillac Ranch",
      Artist: "Chris LeDoux",
      "Album Artist": "Chris LeDoux",
      Album: "20 Greatest Hits",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "6176117",
      "Total Time": "173733",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "15",
      "Track Count": "20",
      Year: "1991",
      "Date Modified": "2021-08-18T04:12:48Z",
      "Date Added": "2021-01-30T03:17:40Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1991-07-22T07:00:00Z",
      Normalization: "4780",
      Compilation: "",
      "Sort Album": "20 Greatest Hits",
      "Sort Artist": "Chris LeDoux",
      "Sort Name": "Cadillac Ranch",
      "Persistent ID": "C16F1A54DFEF1411",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/20%20Greatest%20Hits/15%20Cadillac%20Ranch.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12495",
      Name: "Written In the Stars (feat. Eric Turner)",
      Artist: "Tinie Tempah",
      "Album Artist": "Tinie Tempah",
      Composer:
        "Charlie Bernardo, E Mughal, Eric Turner, Patrick Okogwu, Eshraque Mughal & Tinie Tempah",
      Album: "Disc-Overy",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "7949150",
      "Total Time": "219560",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "8",
      "Track Count": "14",
      Year: "2010",
      "Date Modified": "2021-08-18T04:14:39Z",
      "Date Added": "2021-04-02T21:03:28Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2010-09-19T07:00:00Z",
      Normalization: "10212",
      "Sort Album": "Disc-Overy",
      "Sort Artist": "Tinie Tempah",
      "Sort Name": "Written In the Stars (feat. Eric Turner)",
      "Persistent ID": "1A69FDD4EAD25B93",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Tinie%20Tempah/Disc-Overy/08%20Written%20In%20the%20Stars%20(feat.%20Eric%20Turner).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12497",
      Name: "Wild Wild Life",
      Artist: "Talking Heads",
      "Album Artist": "Talking Heads",
      Composer: "David Byrne, Chris Frantz, Jerry Harrison & Tina Weymouth",
      Album: "The Best of Talking Heads (Remastered)",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "8317518",
      "Total Time": "219700",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "16",
      "Track Count": "18",
      Year: "1986",
      "Date Modified": "2021-08-18T04:14:32Z",
      "Date Added": "2021-04-04T03:56:51Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1986-10-07T07:00:00Z",
      Normalization: "6456",
      Compilation: "",
      "Sort Album": "Best of Talking Heads",
      "Sort Artist": "Talking Heads",
      "Sort Name": "Wild Wild Life",
      "Persistent ID": "8CF08D7248E3B0C7",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20Talking%20Heads%20(Remastered)/16%20Wild%20Wild%20Life.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12499",
      Name: "The Perfect Fan",
      Artist: "Backstreet Boys",
      "Album Artist": "Backstreet Boys",
      Composer: "Brian T. Littrell & Thomas L. Smith",
      Album: "Millennium",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "9737104",
      "Total Time": "253466",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "12",
      "Track Count": "12",
      Year: "1999",
      "Date Modified": "2020-02-28T21:21:21Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1999-05-18T07:00:00Z",
      Normalization: "2398",
      "Sort Album": "Millennium",
      "Sort Artist": "Backstreet Boys",
      "Sort Name": "Perfect Fan",
      "Persistent ID": "B7C9FAEB0B2D8AE6",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Backstreet%20Boys/Millennium/12%20The%20Perfect%20Fan.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12501",
      Name: "Vienna",
      Artist: "Billy Joel",
      "Album Artist": "Billy Joel",
      Composer: "Billy Joel",
      Album: "The Stranger",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "7871859",
      "Total Time": "213924",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "5",
      "Track Count": "9",
      Year: "1977",
      "Date Modified": "2019-10-11T17:08:43Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1977-09-29T07:00:00Z",
      Normalization: "2539",
      "Artwork Count": "1",
      "Sort Album": "Stranger",
      "Sort Artist": "Billy Joel",
      "Sort Name": "Vienna",
      "Persistent ID": "3F16FBECE7FA7DC2",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Billy%20Joel/The%20Stranger/05%20Vienna.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12503",
      Name: "Steady Mobbin'",
      Artist: "Ice Cube",
      "Album Artist": "Ice Cube",
      Album: "Greatest Hits",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "8822028",
      "Total Time": "249906",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "14",
      "Track Count": "17",
      Year: "1991",
      "Date Modified": "2020-11-28T19:42:07Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1991-08-09T07:00:00Z",
      Normalization: "4737",
      Compilation: "",
      "Sort Album": "Greatest Hits",
      "Sort Artist": "Ice Cube",
      "Sort Name": "Steady Mobbin'",
      "Persistent ID": "6F6C118ECAE2C16B",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Greatest%20Hits/14%20Steady%20Mobbin'.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12505",
      Name: "I Want to Hold Your Hand",
      Artist: "Vitamin String Quartet",
      "Album Artist": "Vitamin String Quartet",
      Composer: "John Winston Lennon & Paul James McCartney",
      Album: "VSQ Performs The Beatles, Vol. 2",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "5141627",
      "Total Time": "141160",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "11",
      "Track Count": "11",
      Year: "2011",
      "Date Modified": "2021-04-09T19:33:22Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-12-26T12:00:00Z",
      Normalization: "1353",
      "Sort Album": "VSQ Performs The Beatles, Vol. 2",
      "Sort Artist": "Vitamin String Quartet",
      "Sort Name": "I Want to Hold Your Hand",
      "Persistent ID": "214D2AB0807DDD88",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Vitamin%20String%20Quartet/VSQ%20Performs%20The%20Beatles,%20Vol.%202/11%20I%20Want%20to%20Hold%20Your%20Hand.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12507",
      Name: "Wonderful Tonight",
      Artist: "Eric Clapton",
      "Album Artist": "Eric Clapton",
      Composer: "Eric Clapton",
      Album: "Complete Clapton",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "8202984",
      "Total Time": "219400",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "17",
      "Track Count": "37",
      Year: "1977",
      "Date Modified": "2020-10-09T15:40:54Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1977-11-25T12:00:00Z",
      Normalization: "1230",
      Compilation: "",
      "Sort Album": "Complete Clapton",
      "Sort Artist": "Eric Clapton",
      "Sort Name": "Wonderful Tonight",
      "Persistent ID": "3AEBAAB62B7A4774",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Complete%20Clapton/17%20Wonderful%20Tonight.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12509",
      Name: "This Must Be the Place (Naive Melody)",
      Artist: "Talking Heads",
      "Album Artist": "Talking Heads",
      Composer: "Chris Frantz, David Byrne, Jerry Harrison & Tina Weymouth",
      Album: "The Best of Talking Heads (Remastered)",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "10568822",
      "Total Time": "296072",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "11",
      "Track Count": "18",
      Year: "2004",
      "Date Modified": "2019-10-26T01:00:51Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-08-17T07:00:00Z",
      Normalization: "1204",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Best of Talking Heads",
      "Sort Artist": "Talking Heads",
      "Sort Name": "This Must Be the Place (Naive Melody)",
      "Persistent ID": "03F5B8B11DF9F5E6",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20Talking%20Heads%20(Remastered)/11%20This%20Must%20Be%20the%20Place%20(Naive%20Melody).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12511",
      Name: 'My Heart Will Go On (Love Theme from "Titanic")',
      Artist: "James Horner & Céline Dion",
      "Album Artist": "James Horner",
      Composer: "James Horner",
      Album: "Titanic (Music from the Motion Picture)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "10750168",
      "Total Time": "310733",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "14",
      "Track Count": "15",
      Year: "1997",
      "Date Modified": "2019-04-20T21:17:11Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1997-11-18T08:00:00Z",
      Normalization: "209",
      "Artwork Count": "1",
      "Sort Album": "Titanic",
      "Sort Artist": "James Horner & Céline Dion",
      "Sort Name": 'My Heart Will Go On (Love Theme from "Titanic")',
      "Persistent ID": "FBB104B329263110",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/James%20Horner/Titanic%20(Music%20from%20the%20Motion%20Picture)/14%20My%20Heart%20Will%20Go%20On%20(Love%20Theme%20from%20_Titanic_).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12513",
      Name: 'Rasputin (7" Version)',
      Artist: "Boney M.",
      "Album Artist": "Boney M.",
      Composer: "Frank Farian, Fred Jay & George Reyam",
      Album: "Diamonds (40th Anniversary Edition)",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "11196467",
      "Total Time": "283440",
      "Disc Number": "1",
      "Disc Count": "3",
      "Track Number": "9",
      "Track Count": "19",
      Year: "1991",
      "Date Modified": "2022-08-13T19:34:03Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1991-07-01T12:00:00Z",
      Normalization: "4106",
      Compilation: "",
      "Sort Album": "Diamonds (40th Anniversary Edition)",
      "Sort Artist": "Boney M.",
      "Sort Name": 'Rasputin (7" Version)',
      "Persistent ID": "36F5A47784855BC4",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Diamonds%20(40th%20Anniversary%20Edition)/1-09%20Rasputin%20(7_%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12515",
      Name: "Snap Yo Fingers",
      Artist: "E-40, Lil Jon, Sean Paul & YoungBloodZ",
      "Album Artist": "Lil Jon",
      Album: "Snap Yo Fingers - Single",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "10000295",
      "Total Time": "274386",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "1",
      Year: "2006",
      "Date Modified": "2022-07-23T16:41:26Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2006-02-04T08:00:00Z",
      Normalization: "6488",
      "Sort Album": "Snap Yo Fingers - Single",
      "Sort Artist": "E-40, Lil Jon, Sean Paul & YoungBloodZ",
      "Sort Name": "Snap Yo Fingers",
      "Persistent ID": "CE781F1CD8A8B545",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Lil%20Jon/Snap%20Yo%20Fingers%20-%20Single/01%20Snap%20Yo%20Fingers.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12517",
      Name: "Sweet Transvestite",
      Artist: "Tim Curry",
      "Album Artist": "Various Artists",
      Composer: "Richard Hartley & Richard O'Brien",
      Album:
        "The Rocky Horror Picture Show (Soundtrack from the Motion Picture)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "7450359",
      "Total Time": "204370",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "5",
      "Track Count": "16",
      Year: "1975",
      "Date Modified": "2019-06-22T19:20:00Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1975-01-01T08:00:00Z",
      Normalization: "1959",
      "Artwork Count": "1",
      "Sort Album":
        "Rocky Horror Picture Show (Soundtrack from the Motion Picture)",
      "Sort Artist": "Tim Curry",
      "Sort Name": "Sweet Transvestite",
      "Persistent ID": "0F42EE01FABFD495",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Various%20Artists/The%20Rocky%20Horror%20Picture%20Show%20(Soundtrack%20from%20the%20Motion%20Picture)/05%20Sweet%20Transvestite.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12519",
      Name: "We Do It For Fun Pt. 2",
      Artist: "Tha Joker",
      "Album Artist": "Tha Joker",
      Album: "Family Ties Ent",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "7157297",
      "Total Time": "200646",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "3",
      "Track Count": "9",
      Year: "2009",
      "Date Modified": "2020-09-26T15:20:26Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2009-03-01T12:00:00Z",
      Normalization: "1096",
      "Sort Album": "Family Ties Ent",
      "Sort Artist": "Tha Joker",
      "Sort Name": "We Do It For Fun Pt. 2",
      "Persistent ID": "BE59306419B04C12",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Tha%20Joker/Family%20Ties%20Ent/03%20We%20Do%20It%20For%20Fun%20Pt.%202.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12521",
      Name: "Gloria (Single Version)",
      Artist: "Laura Branigan",
      "Album Artist": "Laura Branigan",
      Composer: "Giancarlo Bigazzi, Trevor Veitch & Umberto Tozzi",
      Album: "The Best of Branigan",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "11207980",
      "Total Time": "295066",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "13",
      "Track Count": "13",
      Year: "1982",
      "Date Modified": "2019-08-09T20:56:10Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1982-03-01T08:00:00Z",
      Normalization: "9153",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Best of Branigan",
      "Sort Artist": "Laura Branigan",
      "Sort Name": "Gloria (Single Version)",
      "Persistent ID": "F76813395C426CCF",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20Branigan/13%20Gloria%20(Single%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12523",
      Name: "Everytime We Touch (Yanou's Candlelight Mix)",
      Artist: "Cascada",
      "Album Artist": "Cascada",
      Album: "Everytime We Touch",
      Genre: "Dance",
      Kind: "Purchased AAC audio file",
      Size: "7036443",
      "Total Time": "195760",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "14",
      "Track Count": "14",
      Year: "2007",
      "Date Modified": "2020-10-15T20:10:25Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2007-03-05T08:00:00Z",
      Normalization: "2657",
      Compilation: "",
      "Sort Album": "Everytime We Touch",
      "Sort Artist": "Cascada",
      "Sort Name": "Everytime We Touch (Yanou's Candlelight Mix)",
      "Persistent ID": "0511724294BD7187",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Everytime%20We%20Touch/14%20Everytime%20We%20Touch%20(Yanou's%20Candlelight%20Mix).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12525",
      Name: "When I Say I Do",
      Artist: "Matthew West",
      "Album Artist": "Matthew West",
      Composer: "Matthew West",
      Album: "Hold You Up - Single",
      Genre: "Christian & Gospel",
      Kind: "Purchased AAC audio file",
      Size: "8582853",
      "Total Time": "246000",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "3",
      Year: "2009",
      "Date Modified": "2019-07-05T17:55:17Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2009-03-31T07:00:00Z",
      Normalization: "4039",
      "Artwork Count": "1",
      "Sort Album": "Hold You Up - Single",
      "Sort Artist": "Matthew West",
      "Sort Name": "When I Say I Do",
      "Persistent ID": "E6CB9239D1E23308",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Matthew%20West/Hold%20You%20Up%20-%20Single/02%20When%20I%20Say%20I%20Do.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12527",
      Name: "Where Is My Mind?",
      Artist: "Pixies",
      "Album Artist": "Pixies",
      Composer: "Black Francis",
      Album: "Surfer Rosa (Remastered)",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "9118144",
      "Total Time": "234973",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "13",
      Year: "1988",
      "Date Modified": "2021-08-18T04:14:17Z",
      "Date Added": "2021-04-18T00:48:02Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1988-03-21T08:00:00Z",
      Normalization: "1180",
      "Sort Album": "Surfer Rosa (Remastered)",
      "Sort Artist": "Pixies",
      "Sort Name": "Where Is My Mind?",
      "Persistent ID": "A7F1A567242B771D",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Pixies/Surfer%20Rosa%20(Remastered)/07%20Where%20Is%20My%20Mind_.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12529",
      Name: "Cowboy Like Me",
      Artist: "Cody Johnson",
      "Album Artist": "Cody Johnson",
      Album: "Cowboy Like Me (Bonus Track Version)",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "10533870",
      "Total Time": "302124",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "13",
      Year: "2014",
      "Date Modified": "2022-07-23T18:23:21Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2014-01-14T08:00:00Z",
      Normalization: "3927",
      "Sort Album": "Cowboy Like Me (Bonus Track Version)",
      "Sort Artist": "Cody Johnson",
      "Sort Name": "Cowboy Like Me",
      "Persistent ID": "060F332B86F1D6B7",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Cody%20Johnson/Cowboy%20Like%20Me%20(Bonus%20Track%20Version)/07%20Cowboy%20Like%20Me.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12531",
      Name: "The Way You Look Tonight (From Father of the Bride)",
      Artist: "Steve Tyrell",
      "Album Artist": "Steve Tyrell",
      Composer:
        "Alan Silvestri, Dorothy Fields, Jerome Kern & Jerome and Dorothy Fields",
      Album: "A New Standard",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "9860035",
      "Total Time": "272852",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "14",
      "Track Count": "17",
      Year: "1999",
      "Date Modified": "2021-04-24T14:21:07Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1999-09-10T12:00:00Z",
      Normalization: "1638",
      "Sort Album": "New Standard",
      "Sort Artist": "Steve Tyrell",
      "Sort Name": "Way You Look Tonight (From Father of the Bride)",
      "Persistent ID": "653CEA346044C827",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Steve%20Tyrell/A%20New%20Standard/14%20The%20Way%20You%20Look%20Tonight%20(From%20Father%20of%20the%20Bride).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12533",
      Name: "Turn the Page",
      Artist: "Metallica",
      "Album Artist": "Metallica",
      Album: "Garage, Inc.",
      Genre: "Metal",
      Kind: "Purchased AAC audio file",
      Size: "13011387",
      "Total Time": "366573",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "27",
      Year: "1998",
      "Date Modified": "2020-01-23T18:03:25Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1998-11-23T08:00:00Z",
      Normalization: "8484",
      Compilation: "",
      "Sort Album": "Garage Inc.",
      "Sort Artist": "Metallica",
      "Sort Name": "Turn the Page",
      "Persistent ID": "90F225D89BDDD33D",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Garage,%20Inc_/04%20Turn%20the%20Page.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12535",
      Name: "When I Said I Do",
      Artist: "Clint Black & Lisa Hartman Black",
      "Album Artist": "Clint Black",
      Composer: "Clint Black",
      Album: "Clint Black: Greatest Hits II",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "9471678",
      "Total Time": "268960",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "16",
      Year: "2001",
      "Date Modified": "2020-08-06T18:47:16Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2001-10-30T08:00:00Z",
      Normalization: "2216",
      Compilation: "",
      "Sort Album": "Clint Black: Greatest Hits II",
      "Sort Artist": "Clint Black & Lisa Hartman Black",
      "Sort Name": "When I Said I Do",
      "Persistent ID": "73B4722414BF4F48",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Clint%20Black_%20Greatest%20Hits%20II/07%20When%20I%20Said%20I%20Do.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12537",
      Name: "Thank You for Being a Friend",
      Artist: "Andrew Gold",
      "Album Artist": "Andrew Gold",
      Composer: "Andrew Gold",
      Album: "Rhino Hi-Five: Andrew Gold - EP",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "11076512",
      "Total Time": "280760",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "5",
      Year: "2005",
      "Date Modified": "2019-09-07T14:33:51Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2005-04-19T07:00:00Z",
      Normalization: "921",
      "Artwork Count": "1",
      "Sort Album": "Rhino Hi-Five: Andrew Gold - EP",
      "Sort Artist": "Andrew Gold",
      "Sort Name": "Thank You for Being a Friend",
      "Persistent ID": "BC967C5036F50D27",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Andrew%20Gold/Rhino%20Hi-Five_%20Andrew%20Gold%20-%20EP/01%20Thank%20You%20for%20Being%20a%20Friend.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12539",
      Name: "Hood Go Crazy (feat. 2 Chainz & B.o.B)",
      Artist: "Tech N9ne",
      "Album Artist": "Tech N9ne",
      Composer: "Tech N9ne",
      Album: "Special Effects",
      Genre: "Hip-Hop",
      Kind: "Purchased AAC audio file",
      Size: "8741775",
      "Total Time": "225040",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "11",
      "Track Count": "24",
      Year: "2015",
      "Date Modified": "2019-08-31T16:29:19Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-05-04T07:00:00Z",
      Normalization: "3430",
      "Artwork Count": "1",
      "Sort Album": "Special Effects",
      "Sort Artist": "Tech N9ne",
      "Sort Name": "Hood Go Crazy (feat. 2 Chainz & B.o.B)",
      "Persistent ID": "55718DF808700DDC",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Tech%20N9ne/Special%20Effects/11%20Hood%20Go%20Crazy%20(feat.%202%20Chainz%20&%20B.o.B).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12541",
      Name: "Love Never Fails",
      Artist: "Brandon Heath",
      "Album Artist": "Brandon Heath",
      Composer: "Brandon Heath, Brandon Heath, Chad Cates & Chad Cates",
      Album: "What If We",
      Genre: "Christian",
      Kind: "Purchased AAC audio file",
      Size: "6752143",
      "Total Time": "186390",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "11",
      Year: "2008",
      "Date Modified": "2020-12-12T04:36:59Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2008-08-19T07:00:00Z",
      Normalization: "2249",
      "Sort Album": "What If We",
      "Sort Artist": "Brandon Heath",
      "Sort Name": "Love Never Fails",
      "Persistent ID": "04DFC1D720521894",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Brandon%20Heath/What%20If%20We/07%20Love%20Never%20Fails.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12543",
      Name: "Bonfire",
      Artist: "Knife Party",
      "Album Artist": "Knife Party",
      Composer: "Gareth McGrillen & Rob Swire",
      Album: "Rage Valley - EP",
      Genre: "Dance",
      Kind: "Purchased AAC audio file",
      Size: "10352473",
      "Total Time": "272077",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "3",
      "Track Count": "4",
      Year: "2012",
      "Date Modified": "2019-10-26T01:00:49Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-05-27T07:00:00Z",
      Normalization: "10472",
      "Artwork Count": "1",
      "Sort Album": "Rage Valley - EP",
      "Sort Artist": "Knife Party",
      "Sort Name": "Bonfire",
      "Persistent ID": "4CF154586A665E3E",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Knife%20Party/Rage%20Valley%20-%20EP/03%20Bonfire.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12545",
      Name: "Calm Down",
      Artist: "G-Eazy",
      "Album Artist": "G-Eazy",
      Composer: "N/A",
      Album: "When It's Dark Out",
      Genre: "Hip-Hop/Rap",
      Kind: "Purchased AAC audio file",
      Size: "4755635",
      "Total Time": "127433",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "8",
      "Track Count": "17",
      Year: "2015",
      "Date Modified": "2019-11-09T02:59:15Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-12-04T08:00:00Z",
      Normalization: "2040",
      "Sort Album": "When It's Dark Out",
      "Sort Artist": "G-Eazy",
      "Sort Name": "Calm Down",
      "Persistent ID": "3774B4F4388B56BB",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/G-Eazy/When%20It's%20Dark%20Out/08%20Calm%20Down.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12547",
      Name: "Rose Dies & Johnse Mourns",
      Artist: "John Debney & Tony Morales",
      "Album Artist": "John Debney & Tony Morales",
      Album: "Hatfields & McCoys (Soundtrack from the Mini Series)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "6510911",
      "Total Time": "175613",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "34",
      "Track Count": "39",
      Year: "2012",
      "Date Modified": "2019-09-13T21:51:14Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-05-22T07:00:00Z",
      Normalization: "895",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Hatfields & McCoys (Soundtrack from the Mini Series)",
      "Sort Artist": "John Debney & Tony Morales",
      "Sort Name": "Rose Dies & Johnse Mourns",
      "Persistent ID": "0E5B57EA60F4BEA6",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Hatfields%20&%20McCoys%20(Soundtrack%20from%20the%20Mini%20Series)/34%20Rose%20Dies%20&%20Johnse%20Mourns.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12549",
      Name: "Sweet Pea",
      Artist: "Amos Lee",
      "Album Artist": "Amos Lee",
      Album: "Supply and Demand",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "4916223",
      "Total Time": "129626",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "7",
      "Track Count": "13",
      Year: "2006",
      "Date Modified": "2019-11-09T02:46:28Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2006-10-03T07:00:00Z",
      Normalization: "1485",
      "Sort Album": "Supply and Demand",
      "Sort Artist": "Amos Lee",
      "Sort Name": "Sweet Pea",
      "Persistent ID": "A27E54F519B99592",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Amos%20Lee/Supply%20and%20Demand/07%20Sweet%20Pea.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12551",
      Name: "Beating Heart Baby",
      Artist: "Head Automatica",
      "Album Artist": "Head Automatica",
      Composer: "C. Bonich, Craig Bonich & Daryl Palumbo",
      Album: "Decadence",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "7297696",
      "Total Time": "203733",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "3",
      "Track Count": "11",
      Year: "2004",
      "Date Modified": "2021-05-15T14:14:43Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2004-08-10T12:00:00Z",
      Normalization: "9400",
      "Sort Album": "Decadence",
      "Sort Artist": "Head Automatica",
      "Sort Name": "Beating Heart Baby",
      "Persistent ID": "AA035A6114780609",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Head%20Automatica/Decadence/03%20Beating%20Heart%20Baby.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12553",
      Name: "Drum Roll",
      Artist: "Sound Effects Library",
      "Album Artist": "Sound Effects Library",
      Album: "300 Sound Effects",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "750203",
      "Total Time": "7285",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "76",
      "Track Count": "300",
      Year: "1994",
      "Date Modified": "2020-06-27T15:42:13Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1994-01-01T12:00:00Z",
      Normalization: "150",
      "Sort Album": "300 Sound Effects",
      "Sort Artist": "Sound Effects Library",
      "Sort Name": "Drum Roll",
      "Persistent ID": "725A316E8B57F7E9",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Sound%20Effects%20Library/300%20Sound%20Effects/76%20Drum%20Roll.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12555",
      Name: "Ooh La La",
      Artist: "Faces",
      "Album Artist": "Faces",
      Composer: "Ronnie Lane & Ron Wood",
      Album: "The Best of Faces: Good Boys... When They're Asleep",
      Genre: "Rock",
      Kind: "Purchased AAC audio file",
      Size: "7940260",
      "Total Time": "214903",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "16",
      "Track Count": "19",
      Year: "1973",
      "Date Modified": "2021-08-18T04:13:11Z",
      "Date Added": "2021-06-12T19:43:19Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1973-06-06T07:00:00Z",
      Normalization: "2101",
      Compilation: "",
      "Sort Album": "Best of Faces: Good Boys... When They're Asleep",
      "Sort Artist": "Faces",
      "Sort Name": "Ooh La La",
      "Persistent ID": "215AECD7C5908F06",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Best%20of%20Faces_%20Good%20Boys...%20When%20They're%20Asleep/16%20Ooh%20La%20La.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12557",
      Name: "Tragic Magic",
      Artist: "Falling In Reverse",
      "Album Artist": "Falling In Reverse",
      Composer: "Dave Holdredge, Michael Baskette & Ronnie Radke",
      Album: "The Drug In Me Is You",
      Genre: "Hard Rock",
      Kind: "Purchased AAC audio file",
      Size: "9091058",
      "Total Time": "246133",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "11",
      Year: "2011",
      "Date Modified": "2019-10-11T17:45:30Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-07-26T07:00:00Z",
      Normalization: "13431",
      "Artwork Count": "1",
      "Sort Album": "Drug In Me Is You",
      "Sort Artist": "Falling In Reverse",
      "Sort Name": "Tragic Magic",
      "Persistent ID": "9B27C3203CA4D5CD",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Falling%20In%20Reverse/The%20Drug%20In%20Me%20Is%20You/02%20Tragic%20Magic.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12559",
      Name: "Little Things",
      Artist: "Good Charlotte",
      "Album Artist": "Good Charlotte",
      Composer: "Benji Madden & Joel Madden",
      Album: "Good Charlotte",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "7860499",
      "Total Time": "203026",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "14",
      Year: "2000",
      "Date Modified": "2020-10-15T20:10:30Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2000-09-26T07:00:00Z",
      Normalization: "5585",
      "Sort Album": "Good Charlotte",
      "Sort Artist": "Good Charlotte",
      "Sort Name": "Little Things",
      "Persistent ID": "612ABF7514181D6D",
      Clean: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Good%20Charlotte/Good%20Charlotte/01%20Little%20Things.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12561",
      Name: "Danger! High Voltage (Soulchild Radio Mix)",
      Artist: "Electric Six",
      "Album Artist": "Electric Six",
      Composer: "Anthony Selph, Joseph Frezza, Steven Nawara & Tyler Spencer",
      Album: "Fire",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "7651884",
      "Total Time": "214600",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "4",
      "Track Count": "13",
      Year: "2003",
      "Date Modified": "2021-08-18T04:13:04Z",
      "Date Added": "2021-04-17T22:46:35Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2003-01-06T12:00:00Z",
      Normalization: "8426",
      "Sort Album": "Fire",
      "Sort Artist": "Electric Six",
      "Sort Name": "Danger! High Voltage (Soulchild Radio Mix)",
      "Persistent ID": "27D6F1885004FBB7",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Electric%20Six/Fire/04%20Danger!%20High%20Voltage%20(Soulchild%20Radio%20Mix).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12563",
      Name: "Man In the Box",
      Artist: "Alice In Chains",
      "Album Artist": "Alice In Chains",
      Composer: "Layne Staley, Jerry Cantrell, M. C. Starr & Sean Kinney",
      Album: "Greatest Hits",
      Genre: "Hard Rock",
      Kind: "Purchased AAC audio file",
      Size: "10189714",
      "Total Time": "287626",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "10",
      Year: "1990",
      "Date Modified": "2021-04-09T19:34:09Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1990-08-21T07:00:00Z",
      Normalization: "7580",
      Compilation: "",
      "Sort Album": "Greatest Hits",
      "Sort Artist": "Alice In Chains",
      "Sort Name": "Man In the Box",
      "Persistent ID": "1EFC4C6B921564B7",
      Explicit: "",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Greatest%20Hits/01%20Man%20In%20the%20Box.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12565",
      Name: "Sports - (Chicago Bulls Theme)",
      Artist: "Bobby Morganstein",
      "Album Artist": "Bobby Morganstein Productions",
      Album: "The Complete Grand Entrance Party, Vol. 6",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "4999263",
      "Total Time": "125173",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "8",
      "Track Count": "51",
      Year: "1993",
      "Date Modified": "2021-08-18T04:12:34Z",
      "Date Added": "2021-05-15T20:58:27Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1993-01-01T12:00:00Z",
      Normalization: "1259",
      "Sort Album": "Complete Grand Entrance Party, Vol. 6",
      "Sort Artist": "Bobby Morganstein",
      "Sort Name": "Sports - (Chicago Bulls Theme)",
      "Persistent ID": "6CD701933280292D",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Bobby%20Morganstein%20Productions/The%20Complete%20Grand%20Entrance%20Party,%20Vol.%206/08%20Sports%20-%20(Chicago%20Bulls%20Theme).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12567",
      Name: "2Yl",
      Artist: "The Front Bottoms",
      "Album Artist": "The Front Bottoms",
      Composer: "Brian Sella, Ciaran O'Donnell, Mathew Uychich & Tom, Warren",
      Album: "Back On Top",
      Genre: "Alternative",
      Kind: "Purchased AAC audio file",
      Size: "9421442",
      "Total Time": "251240",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "9",
      "Track Count": "11",
      Year: "2015",
      "Date Modified": "2020-10-23T17:28:15Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2015-09-18T12:00:00Z",
      Normalization: "8001",
      "Sort Album": "Back On Top",
      "Sort Album Artist": "Front Bottoms",
      "Sort Artist": "Front Bottoms",
      "Sort Name": "2Yl",
      "Persistent ID": "7E7F745B177052DA",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20Front%20Bottoms/Back%20On%20Top/09%202Yl.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12569",
      Name: "Flightless Bird, American Mouth (Wedding Version)",
      Artist: "Vitamin String Quartet",
      "Album Artist": "Vitamin String Quartet",
      Composer: "Sam Beam",
      Album: "The Modern Wedding Collection, Vol. 2",
      Genre: "Classical Crossover",
      Kind: "Purchased AAC audio file",
      Size: "9386839",
      "Total Time": "265640",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "10",
      "Track Count": "12",
      Year: "2011",
      "Date Modified": "2021-07-02T18:50:38Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2011-11-22T12:00:00Z",
      Normalization: "1047",
      Compilation: "",
      "Sort Album": "Modern Wedding Collection, Vol. 2",
      "Sort Artist": "Vitamin String Quartet",
      "Sort Name": "Flightless Bird, American Mouth (Wedding Version)",
      "Persistent ID": "D8D0EE221F18451A",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/The%20Modern%20Wedding%20Collection,%20Vol.%202/10%20Flightless%20Bird,%20American%20Mouth%20(Wedding%20Version).m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12571",
      Name: "Carolina",
      Artist: "Eric Church",
      "Album Artist": "Eric Church",
      Composer: "Eric Church",
      Album: "Carolina",
      Genre: "Country",
      Kind: "Purchased AAC audio file",
      Size: "9899714",
      "Total Time": "279080",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "10",
      "Track Count": "13",
      Year: "2009",
      "Date Modified": "2020-08-21T20:21:11Z",
      "Date Added": "2021-08-18T03:59:03Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2009-03-24T07:00:00Z",
      Normalization: "5161",
      "Sort Album": "Carolina",
      "Sort Artist": "Eric Church",
      "Sort Name": "Carolina",
      "Persistent ID": "367637F76DC757C5",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Eric%20Church/Carolina/10%20Carolina.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12573",
      Name: "Vijencanica",
      Artist: "Serif Konjević",
      "Album Artist": "Various Artists",
      Composer: "Suad Jukić Šule",
      Album: "Folk Hitovi 1",
      Genre: "Pop",
      Kind: "Purchased AAC audio file",
      Size: "6674647",
      "Total Time": "188133",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "1",
      "Track Count": "14",
      Year: "2012",
      "Date Modified": "2020-10-16T15:51:42Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-07-01T07:00:00Z",
      Normalization: "2113",
      Compilation: "",
      "Sort Album": "Folk Hitovi 1",
      "Sort Artist": "Serif Konjević",
      "Sort Name": "Vijencanica",
      "Persistent ID": "1DA42C9B469C30DB",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Folk%20Hitovi%201/01%20Vijencanica.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12575",
      Name: "Sea of Love",
      Artist: "The Honeydrippers",
      "Album Artist": "The Honeydrippers",
      Composer: "G. Khoury and P. Baptise & Khoury and Baptise",
      Album: "The Honeydrippers, Vol. 1 (Expanded) - EP",
      Genre: "Rock & Roll",
      Kind: "Purchased AAC audio file",
      Size: "7016870",
      "Total Time": "183880",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "2",
      "Track Count": "6",
      Year: "1984",
      "Date Modified": "2020-10-15T20:10:37Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "1984-09-24T07:00:00Z",
      Normalization: "2781",
      "Sort Album": "Honeydrippers, Vol. 1 (Expanded) - EP",
      "Sort Album Artist": "Honeydrippers",
      "Sort Artist": "Honeydrippers",
      "Sort Name": "Sea of Love",
      "Persistent ID": "B0FAD00EB28E7807",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/The%20Honeydrippers/The%20Honeydrippers,%20Vol.%201%20(Expanded)%20-%20EP/02%20Sea%20of%20Love.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12577",
      Name: "Swan Lake, Op. 20, Act 2: No. 10 Moderato",
      Artist: "André Previn & London Symphony Orchestra",
      "Album Artist": "London Symphony Orchestra & André Previn",
      Composer: "Pyotr Ilyich Tchaikovsky",
      Album: "Tchaikovsky: Swan Lake",
      Grouping: "Swan Lake, Op. 20, Act 2",
      Work: "Swan Lake, Op. 20, Act 2",
      "Movement Number": "1",
      "Movement Count": "11",
      "Movement Name": "No. 10, Moderato",
      Genre: "Classical",
      Kind: "Purchased AAC audio file",
      Size: "6659690",
      "Total Time": "166373",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "19",
      "Track Count": "55",
      Year: "2012",
      "Date Modified": "2019-05-02T19:44:44Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2012-03-09T08:00:00Z",
      Normalization: "640",
      "Artwork Count": "1",
      "Sort Album": "Tchaikovsky: Swan Lake",
      "Sort Artist": "André Previn & London Symphony Orchestra",
      "Sort Name": "Swan Lake, Op. 20, Act 2: No. 10 Moderato",
      "Persistent ID": "0C5E1F0F67F2F8AA",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/London%20Symphony%20Orchestra%20&%20Andre%CC%81%20Previn/Tchaikovsky_%20Swan%20Lake/19%20Swan%20Lake,%20Op.%2020,%20Act%202_%20No.%2010%20Moderato.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
    {
      "Track ID": "12579",
      Name: "Take Me Out to the Ballgame",
      Artist: "Lonestar",
      "Album Artist": "Various Artists",
      Composer: "Albert von Tilzer & Jack Norworth",
      Album: "Everyone's Hero (Music from the Motion Picture)",
      Genre: "Soundtrack",
      Kind: "Purchased AAC audio file",
      Size: "6014007",
      "Total Time": "162151",
      "Disc Number": "1",
      "Disc Count": "1",
      "Track Number": "9",
      "Track Count": "12",
      Year: "2006",
      "Date Modified": "2019-09-13T20:58:09Z",
      "Date Added": "2021-08-18T03:59:43Z",
      "Bit Rate": "256",
      "Sample Rate": "44100",
      "Release Date": "2006-09-11T07:00:00Z",
      Normalization: "8208",
      Compilation: "",
      "Artwork Count": "1",
      "Sort Album": "Everyone's Hero (Music from the Motion Picture)",
      "Sort Artist": "Lonestar",
      "Sort Name": "Take Me Out to the Ballgame",
      "Persistent ID": "45250297D0F96D10",
      "Track Type": "File",
      Purchased: "",
      Location:
        "file:///Volumes/Song%20Backup%20Storage/iTunes/iTunes%20Media/Music/Compilations/Everyone's%20Hero%20(Music%20from%20the%20Motion%20Picture)/09%20Take%20Me%20Out%20to%20the%20Ballgame.m4a",
      "File Folder Count": "5",
      "Library Folder Count": "1",
    },
  ],
  meta: {
    "Major Version": "1",
    "Minor Version": "1",
    Date: "2022-10-10T19:40:49Z",
    "Application Version": "1.1.6.37",
    Features: "5",
    "Show Content Ratings": "true",
    "Music Folder": "file:///Users/user/Music/Music/Media.localized/",
    "Library Persistent ID": "B37419E8A524BB79",
  },
};
